export const ARTICLE_PAGE = 'article';
export const MOST_POPULAR_PAGE = 'popular';

export const LIVE_RADIO_PAGE = 'WS-LIVE';
export const INDEX_PAGE = 'IDX';
export const FEATURE_INDEX_PAGE = 'FIX';
export const MEDIA_ASSET_PAGE = 'MAP';
export const STORY_PAGE = 'STY';
export const PHOTO_GALLERY_PAGE = 'PGL';
